export default __webpack_public_path__ + "static/media/FK.e0683108.ico";